export const trackPlace = () => {}

export const trackCategory = () => {}

export const trackAvailability = () => {}

export const trackClassSize = () => {}

export const trackScoirSchools = () => {}
